export function fetchAllPermissions() {
  return window.axios
    .get("/identity/permissions/all")
    .then((response) => response.data);
}
